<template>  
  <div class="about-main-container">
    <div class="about-sections-container" v-for="(block, index) in blocksWithoutScrollingText" :key="index + '_'">
      <div v-if="block.type === 'image_banner'">
        <special-image-banner-block :block="block"></special-image-banner-block>
      </div>
       <div v-if="block.type === 'about_fifty_fifty_alt'">
        <special-fifty-fifty-alt :schema="block" />
      </div>
      <div v-if="block.type === 'fifty_fifty'">
        <fifty-fifty :schema="block"  class="ff--special" ></fifty-fifty>
      </div>
       <div v-if="block.type === 'loyalty_section'">
        <special-promotion-loyalty :schema="block"  class="special--loyalty" ></special-promotion-loyalty>
      </div>
    </div>
     
  </div>
</template>
<script>
import AboutImageBannerBlock from '@/scripts/components/sections/AboutImageBannerBlock.vue';
import AboutStory from '@/scripts/components/sections/AboutStory.vue';
import FiftyFifty from '@/scripts/components/sections/FiftyFifty.vue';
import SpecialFiftyFiftyAlt from '@/scripts/components/sections/SpecialFiftyFiftyAlt.vue';
import FeaturedImageLinks from '@/scripts/components/sections/FeaturedImageLinks.vue';
import SpecialImageBannerBlock from '@/scripts/components/sections/SpecialImageBannerBlock.vue'
import SpecialPromotionLoyalty from '../sections/SpecialPromotionLoyalty.vue';




export default {
  name: 'SpecialPromotion',
  components: { SpecialImageBannerBlock, AboutImageBannerBlock, AboutStory, FiftyFifty, SpecialFiftyFiftyAlt, FeaturedImageLinks, SpecialPromotionLoyalty },
  computed: {
    blocksWithoutScrollingText () {
      const usedKeys = []
      const filteredBlocks = []

      this.blocks.forEach((block) => {
        // Filter out Scrolling Text blocks
        if (block.type === 'scrolling_text') {
          // Leave first block of a group for positioning
          if (usedKeys.indexOf(block.settings.group) >= 0) {
            return
          }
          usedKeys.push(block.settings.group)
        }
        filteredBlocks.push(block)
      })

      return filteredBlocks
    }
  },

  props: {
    blocks: {
      type: Array,
      default: () => []
    }
  }
}
</script>